export default {
  methods: {
    validUsername: function(username) {
      if (!username.value) {
        username.error = '请输入昵称！'
        return false
      } else if (username.value && username.value.length > 20) {
        username.error = '请输入昵称！'
        return false
      } else {
        username.error = ''
        return true
      }
    },
    validTel: function(oldTel) {
      var telreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!oldTel.value) {
        oldTel.error = '请输入手机号！'
        return false
      } else if (!telreg.test(oldTel.value)) {
        oldTel.error = '手机号格式错误！'
        return false
      } else {
        oldTel.error = ''
        return true
      }
    },
    validNewTel: function(newTel, oldTel) {
      var telreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!newTel.value) {
        newTel.error = '请输入新手机号！'
        return false
      } else if (newTel.value && newTel.value === oldTel.value) {
        newTel.error = '新手机号不得与当前手机号相同！'
        return false
      } else if (!telreg.test(newTel.value)) {
        newTel.error = '新手机号格式错误！'
        return false
      } else {
        newTel.error = ''
        return true
      }
    },
    validVerifyCode: function(verifyCode) {
      if (!verifyCode.value) {
        verifyCode.error = '请输入验证码！'
      } else {
        verifyCode.error = ''
        return true
      }
    },
    countDown(code) {
      code = 120
      let t = setInterval(() => {
        code--
        if (code === 0) {
          code = '发送验证码'
          clearInterval(t)
        }
      }, 1000)
      return code
    }
  }
}
